import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { Note } from "./note.model";
import { NoteStoreFacade } from "./note.store-facade";
import { NoteApiFacade } from "./note.api-facade";

export class NoteFacade extends RestrictedAccountObjectFacade<Note, NoteApiFacade, NoteStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.facade.ts